class FilteredContent extends HTMLElement {
  constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.showContent = false;
  }

  connectedCallback() {
      if (this.checkFilter()) {
          this.renderContent();
      } else {
          this.appendAndReload();
      }
  }

  checkFilter() {
      const filterKey = this.getAttribute('filter-key');
      const filterValue = this.getAttribute('filter-value');
      const currentUrl = new URL(window.location.href);
      const currentFilterValue = currentUrl.searchParams.get(filterKey);

      return currentFilterValue === filterValue;
  }

  appendAndReload() {
      const filterKey = this.getAttribute('filter-key');
      const filterValue = this.getAttribute('filter-value');
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.set(filterKey, filterValue);
      window.location.href = currentUrl.toString();
  }

  renderContent() {
      this.shadowRoot.innerHTML = `
      <style>
        slot {
          display: block;
        }
      </style>
      <slot></slot>
    `;
  }
}

customElements.define('lux-filtered-content', FilteredContent);